export default __webpack_public_path__ + "static/media/brand-placeholder.e06b39fd.jpg";